var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-radio row no-wrap rounded-borders",style:({
    minHeight: (_vm.minHeight + "px"),
  })},[_c('div',{staticClass:"slide",style:({
      left: ((_vm.width * _vm.activeIndex) + "px"),
      width: (_vm.width + "px"),
    })}),_vm._l((_vm.selections),function(ref,index){
    var icon = ref.icon;
    var label = ref.label;
    var value = ref.value;
    var tooltip = ref.tooltip;
return _c('div',{key:index,class:[
        'query-item',
        'justify-center',
        'items-center',
        'rounded-borders',
        'no-wrap' ].concat([
        _vm.activeIndex === index ? 'active' : '',
        _vm.horizentolOpt !== false ? 'row' : 'column',
        _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer' ]),style:({ width: (_vm.width + "px") }),on:{"click":function($event){return _vm.handleCategoryChange(index)}}},[(icon)?_c('q-icon',{staticClass:"q-mr-sm",class:{
        'q-mr-sm': _vm.horizentolOpt !== false,
      },attrs:{"name":("fad fa-" + icon)}}):_vm._e(),_c('span',{staticStyle:{"font-size":"0.65rem"}},[_vm._v(_vm._s(label))]),(tooltip)?_c('q-tooltip',[_vm._v(_vm._s(tooltip))]):_vm._e()],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }